import React, { useState } from 'react';
import { ButtonSet, Modal, ModalBody } from 'carbon-components-react';
import { Button } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';
import messages from '../../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { segmentTracking } from '../../../lib/tracker';
import './Landing.scss';
import PublicImage from 'src/common/components/PublicImage';

type LandingProps = {
  handleLaunchModal: () => void;
  setOpenLanding: React.Dispatch<React.SetStateAction<boolean>>;
  setPathSelected: React.Dispatch<React.SetStateAction<string>>;
};

export const Landing = ({
  handleLaunchModal,
  setOpenLanding,
  setPathSelected,
}: LandingProps) => {
  const [openLandingModal, setOpenLandingModal] = useState(true);
  const picture = 'images/landing.png';

  return (
    <div className="bx--grid watsonxsa_widget">
      <div className="Landing">
        <Modal
          passiveModal={true}
          open={openLandingModal}
          size={'lg'}
          onRequestClose={() => {
            segmentTracking('CTA Clicked', {
              pageTitle: 'Watsonx Orchestrate SA',
              object: 'Watsonx Orchestrate SA',
              resultValue: 'CTA clicked',
              CTA: 'Form modal closed on the corner',
              location: 'URX Form',
              action: `Form modal closed`,
              field: '',
            });
            setOpenLandingModal(false);
            setOpenLanding(false);
          }}
        >
          <ModalBody hasForm className="ModalBody">
            <div className="bx--row nam">
              <div className="bx--col-lg-11 bx--col-md-5 bx--col-sm-3">
                <div className="bx-row landingDiv1">
                  <div>
                    <p className="type1">
                      <FormattedMessage {...messages.landingTitle} />
                    </p>
                  </div>
                  <div className="mar-02">
                    <p className="type2">
                      <FormattedMessage {...messages.landingSubTitle} />
                    </p>
                  </div>
                  <div className="mar-top-06">
                    <p className="type3">
                      <FormattedMessage {...messages.landingText1} />
                    </p>
                  </div>
                  <div className="mar-top-06">
                    <p className="type3">
                      <FormattedMessage {...messages.landingText2} />
                    </p>
                  </div>
                </div>
              </div>
              <div className="bx--col-lg-5 bx--col-md-3 bx--col-sm-3">
                <div className="bx--row landingDiv2">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <PublicImage
                      imgPath={picture}
                      widgetId="watsonx-orchestrate-self-assessment"
                      id="img1"
                      alt="Watsonx orchestrate SA landing picture "
                    />
                  </div>
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <div className="type2">
                      <FormattedMessage {...messages.pathSelectTitle} />
                    </div>
                  </div>
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <ButtonSet
                      className="landingDiv2__stack-button btn-set"
                      stacked
                    >
                      <Button
                        renderIcon={ArrowRight16}
                        kind="primary"
                        onClick={() => {
                          handleLaunchModal(),
                            setPathSelected('Non-Tech'),
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'Watsonx Orchestrate SA',
                              object: 'Watsonx Orchestrate SA',
                              resultValue: 'CTA clicked',
                              CTA: 'Non-Tech Path Selection',
                              location: 'Watsonx Orchestrate SA',
                              action: '',
                              field: '',
                            });
                        }}
                      >
                        <FormattedMessage {...messages.path1Btn} />
                      </Button>
                      <Button
                        renderIcon={ArrowRight16}
                        kind="primary"
                        onClick={() => {
                          handleLaunchModal(),
                            setPathSelected('Tech'),
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'Watsonx Orchestrate SA',
                              object: 'Watsonx Orchestrate SA',
                              resultValue: 'CTA clicked',
                              CTA: 'Tech Path Selection',
                              location: 'Watsonx Orchestrate SA',
                              action: '',
                              field: '',
                            });
                        }}
                      >
                        <FormattedMessage {...messages.path2Btn} />
                      </Button>
                    </ButtonSet>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};
